// Shared by the Planning and its detail panel.
export const statusColors = { "Instalación programada": "#f59e0b", "Instalado": "#22c55e", "Validado": "#15803d", "Anulado": "#ef4444" };
export const EQUIPE_COLORS = { equipe1: "#8b5cf6", equipe2: "#f97316", equipe3: "#475569" };
export const EQUIPE_LABELS = { equipe1: "Equipo 1", equipe2: "Equipo 2", equipe3: "Equipo 3" };
